export const environment = {
    production: false,
    sel: 'mLj28Bnq9354pMVw7EQx',
    apiUrl: 'https://allin-a8717.firebaseio.com/',
    facebook: 'https://www.facebook.com/pages/category/Product-Service/ALL-IN-111845233791092/',
    instagram: 'https://instagram.com/all.in_sur_mesure?igshid=1bfhqyydga2mc'
}